(function () {
  function init() {
    if (window.__rzUnit) return; window.__rzUnit = 1;
    if (location.pathname.indexOf('/products/') === -1) return;
    var handle = location.pathname.split('/products/')[1].split('?')[0].split('#')[0].replace(/\/+$/, '');
    if (!handle) return;
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var V = (p && p.variants) || [];
      if (!V.length) return;
      function findHost() {
        var priceEl = document.querySelector('.product__info-wrapper .price, .product__info-container .price, product-info .price, .price--large') || document.querySelector('main .price') || document.querySelector('.price');
        if (!priceEl) return null;
        var wrap = priceEl.closest('[id^=\"price-\"]');
        return wrap || priceEl;
      }
      function fmt(n) { return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
      function currentId() {
        var s = document.querySelector('form[action*=\"/cart/add\"] [name=\"id\"]');
        if (s && s.value) return parseInt(s.value, 10);
        var q = new URLSearchParams(location.search).get('variant');
        return q ? parseInt(q, 10) : V[0].id;
      }
      function ensure() {
        var el = document.getElementById('rz-cu');
        if (el && document.body.contains(el)) return el;
        var host = findHost();
        if (!host) return null;
        el = document.createElement('div');
        el.id = 'rz-cu';
        el.style.cssText = 'font-weight:700;color:#0a7d33;margin:2px 0 8px;font-size:15px;line-height:1.4';
        var tax = document.querySelector('.product__tax');
        if (tax) { tax.insertAdjacentElement('afterend', el); } else { host.insertAdjacentElement('afterend', el); }
        return el;
      }
      function upd() {
        var el = ensure();
        if (!el) return;
        var id = currentId();
        var v = null;
        for (var i = 0; i < V.length; i++) { if (V[i].id === id) { v = V[i]; break; } }
        if (!v) v = V[0];
        var m = (v.title || '').match(/\d[\d,]*/);
        if (!m) { el.style.display = 'none'; return; }
        var pzs = parseInt(m[0].replace(/,/g, ''), 10);
        if (!pzs || pzs < 2) { el.style.display = 'none'; return; }
        el.style.display = '';
        el.textContent = fmt((v.price / 100) / pzs) + ' c/u \u00b7 paquete ' + pzs.toLocaleString('es-MX') + ' \u00b7 env\u00edo incluido';
      }
      var tries = 0;
      var timer = setInterval(function () {
        if (findHost()) { clearInterval(timer); upd(); }
        else if (++tries > 24) { clearInterval(timer); }
      }, 250);
      document.addEventListener('change', function (e) {
        if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, form[action*=\"/cart/add\"]')) {
          setTimeout(upd, 120);
          setTimeout(upd, 700);
        }
      });
    }).catch(function () {});
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
